import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import SearchIcon from './SearchIcon';
import Wrapper from './Wrapper';
import Svg from '../../_assets/svg';

const Search = (props) => {
  const { placeholder, className, onChange, value, color, minWidth } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Wrapper className={className} minWidth={minWidth}>
      <Input color={color} placeholder={placeholder} value={value} onChange={handleChange} />
      <SearchIcon src={Svg.search.default} alt="search" />
    </Wrapper>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

Search.defaultProps = {
  placeholder: '',
  className: '',
};

export default Search;
